import React, { Component } from "react";
import {
  Popup,
  Sidebar,
  Segment,
  Menu,
  Icon,
  List,
  Button,
  Transition,
  Message
} from "semantic-ui-react";
import Swipeable from "react-swipeable";
import { killfeedback } from "./actions/feedback";
import { Link } from "react-router";
import "./App.css";
import MatEntryModal from "./components/shared-components/matentrymodal";
import EstimateSearchModal from "./components/shared-components/estimatesearchmodal";
import socketHandle from "./actions/socket-handle";
import { store, socket } from ".";
import EstimateModal from "./components/shared-components/estimatemodal";
import { modalhandler } from "./actions/modal-handler";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { LogoutService } from "./services/loginservice";
import { ToggleCollapse } from "./actions/toggle-collapse";
import { InitialTime } from "./actions/initial-time";
import AppBanner from "./AppBanner";
import isMobile from "ismobilejs";
import { loginhandler } from "./actions/loginhandler";
import { datapop } from "./actions/data-populate";
import { MobileHandler } from "./actions/mobile-handler.js";
import LoginModal from "./components/shared-components/loginmodal";
import Authoritay from "./components/shared-components/Nope";
import MessagerModal from "./components/messaging/messagingmodal";
import LoaderModal from "./components/shared-components/loadingmodal";
import PasswordModal from "./components/shared-components/ResetPassModal";
import WodSearchModal from "./components/wod/wodsearchmodal";
import InvSearchModal from "./components/accounting/invoices/invsearchmodal";
import estquery from "./services/estquery";
class App extends Component {
  state = {
    socketKey: "",
    loginOpen: false,
    email: "",
    password: "",
    emaildomain: "",
    sidecollapse: true,
    sidebarsize: "thin",
    iconsize: "large",
    sidebaranimation: "push",
    pushableid: "Pushable",
    logoid: "logo",
    mainid: "appmain",
    sidebarid: "sidebardesktop",
    allclear: false,
    messageTab: 0,
    modalTab: 0
  };
  componentWillMount() {
    if (window.localStorage.getItem("token") === null) {
      store.dispatch(loginhandler("logout"));
    }
    if (isMobile.any) {
      this.setState({
        sidebaranimation: "overlay",
        sidecollapse: false,
        pushableid: "PushableMobile",
        logoid: "logomobile",
        mainid: "appmainMobile",
        sidebarid: "sidebarMobile"
      });
      this.props.InitialTime();
    }
    this.props.MobileHandler(isMobile.any);
  }
  componentWillReceiveProps(nextProps) {
    console.log("stuff");
    if (nextProps.location.pathname != this.props.location.pathname) {
      this.props.datapop(null, "AccessRenewel");
    }
  }
  handleloader() {
    if (
      (!this.props.myinfo ||
        !this.props.customers ||
        !this.props.customers.length) &&
      this.props.modal !== "loading"
    ) {
      this.props.handlemodal("loading");
    } else if (
      this.props.myinfo &&
      this.props.customers &&
      this.props.customers.length &&
      this.props.modal === "loading"
    ) {
      console.log("app setting modal");
      this.props.handlemodal("none");
    }
  }

  handleaccess() {
    if (this.props.access) {
      return <div id="Children">{this.props.children}</div>;
    } else {
      return <Authoritay />;
    }
  }
  genMenu(mobile) {
    var myname;
    if (this.props.myinfo) {
      myname = this.props.myinfo.firstname + " " + this.props.myinfo.lastname;
    }
    if (mobile) {
      return (
        <Menu size="small" borderless>
          <Menu.Item>
            <AppBanner mobile />
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              <h3>EDF Labor Works v3</h3>
            </Menu.Item>
            <Menu.Item>
              <img
                className="kittens"
                alt="EDF Logo"
                src={require("./edf_logo.bmp")}
                id={this.state.logoid}
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      );
    } else {
      return (
        <Menu size="small" borderless id="topbardesktop">
          <Menu.Item>
            <AppBanner />
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item>
              <h4 id="nameheader">{myname}</h4>
            </Menu.Item>
            <Menu.Item>
              <img
                className="kittens"
                alt="EDF Logo"
                src={require("./edf_logo.bmp")}
              />
              <h2>EDF Labor Works </h2>
              <p>v3</p>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      );
    }
  }

  genreactivesidebar() {
    if (this.props.menu && this.props.myinfo) {
      return this.props.menu.map(entry => {
        if (entry.list) {
          return (
            <Popup
              trigger={
                <Menu.Item name={entry.title}>
                  <Icon name={entry.IconName} size={this.state.iconsize} />
                  {entry.title}
                </Menu.Item>
              }
              position="right center"
              hoverable
            >
              <List divided relaxed>
                {this.genSubEntry(entry.list)}
              </List>
            </Popup>
          );
        } else if (entry.modal) {
          if (this.props.wods) {
            return (
              <Menu.Item
                name="info"
                onClick={() => this.props.handlemodal(entry.modal)}
              >
                <Icon name={entry.IconName} size={this.state.iconsize} />
                {entry.title}
              </Menu.Item>
            );
          }
        } else {
          return (
            <Menu.Item name="info" as={Link} to={entry.link}>
              <Icon name={entry.IconName} size={this.state.iconsize} />
              {entry.title}
            </Menu.Item>
          );
        }
      });
    } else if (this.props.modal !== "login") {
      this.props.handlemodal("loading");
    }
  }
  genSubEntry(list) {
    return list.map(item => {
      if (item.link) {
        return (
          <List.Item>
            <List.Content>
              <List.Description as={Link} to={item.link}>
                {item.name}
              </List.Description>
            </List.Content>
          </List.Item>
        );
      } else if (item.modal) {
        return (
          <List.Item>
            <List.Content>
              <List.Description
                as={Link}
                onClick={() => this.props.handlemodal(item.modal)}
              >
                {item.name}
              </List.Description>
            </List.Content>
          </List.Item>
        );
      }
    });
  }

  genSideBar(mobile) {
    if (mobile) {
      return (
        <div id="sidebarmenu">
          <Menu.Item name="home" as={Link} to="/">
            <Icon name="home" size={this.state.iconsize} />
            Home
          </Menu.Item>
          <Menu.Item name="time" as={Link} to="/time-entry">
            <Icon name="hourglass start" size={this.state.iconsize} />
            Time Entry
          </Menu.Item>
          <Menu.Item
            name="time"
            onClick={() => this.props.handlemodal("matentry")}
          >
            <Icon name="shopping cart" size={this.state.iconsize} />
            Materials
          </Menu.Item>
          <MatEntryModal mobile />
        </div>
      );
    } else {
      return (
        <div id="sidebarmenu">
          {this.genreactivesidebar()}
          <Menu.Item
            name="info"
            onClick={() => this.props.handlemodal("resetpass")}
          >
            <Icon name="asterisk" size={this.state.iconsize} />
            Change Password
          </Menu.Item>
          <Menu.Item name="info" onClick={() => LogoutService()}>
            <Icon name="log out" size={this.state.iconsize} />
            Log Out
          </Menu.Item>
        </div>
      );
    }
  }
  genFeedback() {
    return (
      <Transition
        visible={this.props.feedback.color !== "none"}
        animation="scale"
        duration={200}
      >
        <div id="feedback">
          <Message
            header={this.props.feedback.header}
            icon={this.props.feedback.icon}
            content={this.props.feedback.body}
            color={this.props.feedback.color}
          />
          {this.props.feedback.header === "Error" ? (
            <Button icon onClick={() => window.print()}>
              <Icon name="printer" />
            </Button>
          ) : (
            <div />
          )}
        </div>
      </Transition>
    );
  }
  createestimeatedata(newinfo) {
    estquery(newinfo);
  }
  render() {
    socket.on("Feathers Update", payload => {
      if (payload.key !== this.props.socketKey) {
        store.dispatch(socketHandle(payload));
      }
    });
    if (this.props.feedback.color !== "none") {
      let feedbacktimer = this.props.feedback.header === "Error" ? 7000 : 1600;
      setTimeout(() => this.props.killfeedback(), feedbacktimer);
    }

    this.handleloader();
    const emaildomains = [
      { key: "edf", text: "@edfinc.com", value: "@edfinc.com" },
      { key: "pwps", text: "@pwps.com", value: "@pwps.com" },
      { key: "gmail", text: "@gmail.com", value: "@gmail.com" }
    ];
    var invoices = this.props.invoices;

    if (this.props.modal !== "loading") {
      if (invoices.length && this.props.customers.length) {
        invoices = this.props.invoices.map(inv => {
          inv.customer = this.props.customers.find(
            c => c.custnumber === inv.custnumber
          );
          return inv;
        });
      }
      return (
        <div className="App" id={this.state.mainid}>
          {this.genFeedback()}

          <Swipeable
            onSwipedRight={() => this.setState({ sidecollapse: true })}
            onSwipedLeft={() => this.setState({ sidecollapse: false })}
          >
            {this.genMenu(this.props.mobile)}
          </Swipeable>
          <Sidebar.Pushable as={Segment} id="sidebar">
            <Sidebar
              id={this.state.sidebarid}
              as={Menu}
              animation={this.state.sidebaranimation}
              width={this.state.sidebarsize}
              visible={this.state.sidecollapse}
              icon="labeled"
              vertical
              inverted
            >
              {this.genSideBar(isMobile.any)}
            </Sidebar>

            <Sidebar.Pusher>
              <Segment basic>
                <div id={this.state.pushableid} class="children">
                  {this.handleaccess()}
                </div>
              </Segment>
            </Sidebar.Pusher>
          </Sidebar.Pushable>
          <MessagerModal
            employees={this.props.employees}
            handletabchange={(tabtype, tabindex) =>
              this.setState({ [tabtype]: tabindex })
            }
            myinfo={this.props.myinfo}
            modalindex={this.props.modaltab}
            messageindex={this.state.messageTab}
            messages={this.props.messages}
            alerts={this.props.alerts}
            showModal={this.props.modal === "messaging"}
            handleclose={() => this.props.handlemodal("none")}
          />
          <PasswordModal />
          <EstimateSearchModal />
          <WodSearchModal
            ref="wodsearch"
            workorders={this.props.wods.map(wod => {
              Object.keys(wod).forEach(w => {
                if (wod[w] === null) {
                  wod[w] = ''
                }
              })
              return wod
            })}
            showModal={this.props.modal === "wodsearch"}
            handleclose={() => this.props.handlemodal("none")}
          />
          <InvSearchModal
            ref="invsearch"
            invoices={invoices}
            customers={this.props.customers}
            showModal={this.props.modal === "invsearch"}
            handleclose={() => this.props.handlemodal("none")}
          />
          <LoginModal />
          <EstimateModal
            populatestuff={(billinginfo, program, location, pminfo) => {
              let newinfo = {
                billing: billinginfo,
                program: program,
                location: location,
                pminfo: pminfo
              };
              this.createestimeatedata(newinfo);
            }}
            showModal={this.props.modal === "estimates"}
            handleclose={() => this.props.handlemodal("none")}
            billinginfo={this.props.billinginfo}
            programs={this.props.programs}
            locations={this.props.locations}
            pms={this.props.pminfo}
          />
        </div>
      );
    } else {
      return <LoaderModal />;
    }
  }
}
function mapStateToProps(state) {
  return {
    socketKey: state.socketKey,
    feedback: state.feedback,
    billinginfo: state.custinfo.billing,
    programs: state.custinfo.programs,
    locations: state.custinfo.locations,
    pminfo: state.custinfo.engassigned,
    customers: state.custinfo.customers,
    employees: state.employees.employees,
    messagetab: state.messages.messagetab,
    modaltab: state.messages.modaltab,
    alerts: state.messages.alerts,
    messages: state.messages.messages,
    wods: state.workorders.derivitives,
    menu: state.myinfo.menulist,
    modal: state.modal,
    mobile: state.mobile,
    myinfo: state.myinfo.employeeinfo,
    access: state.myinfo.accessstatus,
    assignedjobs: state.jobs.assignedjobs,
    invoices: state.invoices.all
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      datapop: datapop,
      killfeedback: killfeedback,
      ToggleCollapse: ToggleCollapse,
      InitialTime: InitialTime,
      MobileHandler: MobileHandler,
      handlemodal: modalhandler
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js